module.exports = __webpack_public_path__ + "img/hz_23.72c01892.jpg";